var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2C1 2 0 3 0 4.5V17.5C0 19 1 20 2.5 20H21.5C23 20 24 19 24 17.5625V4.5C24 3 23 2 21.6016 2H2.5ZM12 4.65077C13.7223 4.65077 15.3742 5.35256 16.592 6.60174C17.8099 7.85092 18.4941 9.54515 18.4941 11.3118C18.4941 13.0784 17.8099 14.7726 16.592 16.0218C15.3742 17.271 13.7223 17.9727 12 17.9727C10.2777 17.9727 8.62585 17.271 7.40797 16.0218C6.19008 14.7726 5.50588 13.0784 5.50588 11.3118C5.50588 9.54515 6.19008 7.85092 7.40797 6.60174C8.62585 5.35256 10.2777 4.65077 12 4.65077Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H16C16.5214 0 17 0.465198 17 1V3C17 3.5348 16.5214 4 16 4H8C7.4786 4 7 3.5348 7 3V1C7 0.465198 7.4786 0 8 0Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0824 11.3116C17.0824 12.6942 16.5469 14.0201 15.5938 14.9977C14.6407 15.9754 13.348 16.5246 12 16.5246C10.6521 16.5246 9.35941 15.9754 8.40628 14.9977C7.45316 14.0201 6.91769 12.6942 6.91769 11.3116C6.91769 9.92908 7.45316 8.60316 8.40628 7.62554C9.35941 6.64792 10.6521 6.0987 12 6.0987C13.348 6.0987 14.6407 6.64792 15.5938 7.62554C16.5469 8.60316 17.0824 9.92908 17.0824 11.3116Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImaging);
export default __webpack_public_path__ + "static/media/Imaging.0397f1c885c185a94c725a61a2f546fd.svg";
export { ForwardRef as ReactComponent };